import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useAppSelector } from "../hooks/hooks";
import RenderOptions from "../Components/RenderOptions";
import useUserConfiguration from "../utils/updateUserConfiguration";
import { makeSessionRequest } from "../utils/makeSessionRequest";
export default function SecondaryBar({ secondaryBarHidden, highlightSecondaryBar, closeSecondaryBar, }) {
    const [data, setData2] = useState();
    const { updateUserConfiguration, getSelectedOption: getSelectedOption2 } = useUserConfiguration();
    const primaryBarSelection = useAppSelector((state) => state.configuration.primaryBarSelection);
    const disabledFeatures = useAppSelector((state) => state.configuration.disabledFeatures);
    const configData = useAppSelector((state) => state.configData.current);
    useEffect(() => {
        try {
            if (primaryBarSelection) {
                const getSecondaryBar2Data = () => {
                    return configData.filter((item) => {
                        return item.name === primaryBarSelection.name;
                    })[0].options;
                };
                const secondryBarOptions = getSecondaryBar2Data();
                setData2(secondryBarOptions);
            }
        }
        catch (error) {
            console.error(error);
        }
    }, [configData, primaryBarSelection, primaryBarSelection === null || primaryBarSelection === void 0 ? void 0 : primaryBarSelection.name]);
    const getSelectedOption = (subFeatureName) => {
        var _a;
        return (_a = getSelectedOption2(primaryBarSelection === null || primaryBarSelection === void 0 ? void 0 : primaryBarSelection.name, subFeatureName)) === null || _a === void 0 ? void 0 : _a.filter((x) => typeof x !== "undefined");
    };
    const handleOptionSelection2 = (obj) => {
        updateUserConfiguration(primaryBarSelection === null || primaryBarSelection === void 0 ? void 0 : primaryBarSelection.name, obj);
    };
    const hasSubFeatures = (features) => {
        return features[0].options ? true : false;
    };
    return (_jsxs("div", Object.assign({ className: "z-20 w-max overflow-hidden bg-white px-1 flex absolute shadow-xl rounded-xl flex-col transform transition-all", style: {
            right: "5%",
            maxHeight: "80%",
            minWidth: "220px",
            maxWidth: "320px",
            height: "max-content",
            transform: secondaryBarHidden ? "translateX(150%)" : "",
        } }, { children: [_jsx("div", Object.assign({ className: "flex mt-4 cursor-pointer py-1 items-center" }, { children: _jsx("h1", Object.assign({ className: "text-sm 2xl:text-xl pl-4 font-bold mr-auto items-center justify-center" }, { children: primaryBarSelection === null || primaryBarSelection === void 0 ? void 0 : primaryBarSelection.name })) })), _jsx("div", Object.assign({ style: { height: "max-content" }, className: " overflow-y-auto mb-5" }, { children: data && hasSubFeatures(data) ? (data
                    .filter((subFeature) => !disabledFeatures.includes(subFeature.name))
                    .map((subFeature) => (_jsx(RenderOptions, { selectedValue: getSelectedOption(subFeature.name)
                        .map((option) => option.name)
                        .join(","), item: subFeature, handleOptionSelection: handleOptionSelection2, getSelectedOption: getSelectedOption })))) : (_jsx(RenderOptions, { selectedValue: getSelectedOption("")
                        .map((option) => option.name)
                        .join(","), item: Object.assign(Object.assign({}, primaryBarSelection), { name: "", options: data }), handleOptionSelection: handleOptionSelection2, getSelectedOption: getSelectedOption })) })), _jsx("div", Object.assign({ className: "w-full bg-white " }, { children: _jsx("button", Object.assign({ style: {
                        backgroundColor: highlightSecondaryBar ? "#555" : "",
                        width: "90%",
                    }, className: "tracking-widest w-full text-xs 2xl:text-sm my-4 py-3 mx-2 px-8 hover:bg-black bg-customBlack-light text-white rounded-full font-bold transform transition-colors", onClick: () => {
                        closeSecondaryBar();
                        makeSessionRequest("closed_secondary_modal");
                    } }, { children: "Close" })) }))] })));
}
